export const RAZORPAY_KEY_ID = 'rzp_live_zhK0kJ59DRSStE';

export const initializeRazorpay = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

export const getRazorpayOptions = (orderData) => ({
  key: RAZORPAY_KEY_ID,
  amount: orderData.amount,
  currency: "INR",
  name: "Panchali Boutique",
  description: `Order Payment - ${orderData.items?.length || 0} items`,
  order_id: orderData.razorpay_order_id,
  prefill: {
    name: `${orderData.shipping_address?.first_name} ${orderData.shipping_address?.last_name}`,
    email: orderData.shipping_address?.email,
    contact: orderData.shipping_address?.phone
  },
  modal: {
    escape: false
  },
  retry: {
    enabled: true,
    max_count: 3
  },
  notes: {
    address: orderData.shipping_address?.street_address_1
  },
  theme: {
    color: "#2C3E50"
  }
});

